export const LEGAL_IMPRINT_HEADING: string = `

<center>
	<h1 style="margin-bottom: 0">Imprint / Legal Notice</h1>
	Legal Identity and Responsibility
</center>

---

## Legal Identity

*Also Referred to as “Impressum” in German Law*
`;
